import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Config from '@skin_config';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import LoaderButton from '@common/components/loaderButton';

import { formatMoneyAmount } from '@common/helpers/amount';
import { useBalance } from '@app/dev/terminal/hooks/balance';
import { GetCurrencyConfig } from '@common/helpers/selectors';

import './style.scss';

const CashoutConfirm = ({
  loading,
  amount,
  isMaxAmount,
  onSubmit,
}) => {
  const [{ closePopup }] = useContext(PopupContext);
  const balance = useBalance();
  const currencyConfig = useSelector((state) => (
    GetCurrencyConfig(state, Config.main.currencySymbolRounding)
  ));

  const visualAmount = isMaxAmount ? balance : amount;

  const t = useTranslation();

  return (
    <div className="popup-content popup-small cashout-confirm-popup">
      <h3 className="popup-title">{t('Cash out')}</h3>

      <i onClick={closePopup} className="global-icon icon-Close close-popup" />

      <p className="popup-subtitle">
        {t.jsx('You are about to cash out {1}', <span className="color-hero">{formatMoneyAmount(visualAmount, Config, currencyConfig)}</span>)}
      </p>

      <div className="popup-main-content">
        <i className="global-icon icon-cashout popup-main-icon" />
      </div>

      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={() => closePopup()}
        >
          {t('Cancel')}
        </button>

        <LoaderButton
          type="button"
          onClick={() => onSubmit?.()}
          className="popup-confirm-button"
          loading={loading}
        >
          {t('Cash out')}
        </LoaderButton>
      </div>
    </div>
  );
};

CashoutConfirm.propTypes = {
  loading: PropTypes.bool,
  amount: PropTypes.number,
  isMaxAmount: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default CashoutConfirm;
